<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-reportincompleted></create-reportincompleted>
    </div>
  </div>
</template>

<script>
import CreateReportincompleted from "../../components/CreateReportincompleted.vue";

export default {
  components: {
    CreateReportincompleted
  },
  name: "Reportincompleted",
  data() {
    return {
      items: [],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {}
};
</script>
<style></style>
